import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DetailInfoTypeComponent } from '../detail-info-type.component';
import { InputContentDataExtraValueType, InputContentDataType } from 'client/models';
import { IDataStringExtraValue } from 'common/model';

@Component({
  selector: 'detail-info-checkbox',
  templateUrl: './detail-info-checkbox.component.html',
  standalone: false
})
export class DetailInfoCheckboxComponent extends DetailInfoTypeComponent implements OnInit, OnDestroy {

  private subs = new Subscription();

  public InputContentDataExtraValueType = InputContentDataExtraValueType;

  ngOnInit() {
    super.ngOnInit();
    const value: IDataStringExtraValue[] | undefined = this.formControlObj.value; // We save key in api but value in formObject
    const validValue = this.getValidValues(value);
    this.formControlObj.setValue(validValue);

    this.detailInfo.inputContentDatas.forEach(inputContentDataType => {
      if (validValue && validValue.some(({ dataStringValue }) => dataStringValue === inputContentDataType.key)) {
        inputContentDataType.checked = true;
        inputContentDataType.extraValue = validValue.find(({ dataStringValue }) => dataStringValue === inputContentDataType.key).dataStringExtraValue;
      }
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private getValidValues(values: IDataStringExtraValue[] | undefined): IDataStringExtraValue[] | undefined {
    if (!values) {
      return;
    }
    const validValues = [];
    values.forEach((val) => {
      if (this.detailInfo.inputContentDatas.some(({ key }) => key && key.toString() === val.dataStringValue.toString()))
        validValues.push(val)
    })
    return validValues;
  }

  public selectOption($event, inputContentDataType: InputContentDataType) {
    // Locked (read-only) note: ignore any interaction that slips past the disabled attribute.
    if (this.formControlObj.disabled) { return; }
    const target = $event.target;
    const key: string = target.value;
    const optionControl = this.formControlObj as FormControl;
    const options: IDataStringExtraValue[] = optionControl.value ?? [];

    if (target.checked) {
      inputContentDataType.checked = true;
      const option = options.find(item => item.dataStringValue === inputContentDataType.key);
      if (option) {
        option.dataStringValue = key;
        option.dataStringExtraValue = inputContentDataType.extraValue;
        optionControl.setValue([...options]);
      } else {
        options.push({ dataStringValue: key, dataStringExtraValue: inputContentDataType.extraValue })
      }
      optionControl.setValue(options);
    } else {
      inputContentDataType.checked = false;
      const otherOptions = options.filter(option => option.dataStringValue !== key);
      optionControl.setValue(otherOptions);
    }
  }

  public onExtraOptionValueChange(inputContentDataType: InputContentDataType) {
    const optionControl = this.formControlObj as FormControl;
    const options: Array<IDataStringExtraValue> = optionControl.value ?? [];
    const option = options.find(item => item.dataStringValue === inputContentDataType.key);
    if (option) {
      option.dataStringExtraValue = inputContentDataType.extraValue
      optionControl.setValue([...options]);
    }
  }

}
